import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const report = {
  namespaced: true,

  state: () => ({
    // dashboard summary
    totalPendingTransactionNumber: 0,
    totalPendingTransactionAmount: 0,
    totalFailedTransactionNumber: 0,
    totalFailedTransactionAmount: 0,
    totalSuccessfulTransactionNumber: 0,
    totalSuccessfulTransactionAmount: 0,
    dateRange: '',
    dateArray: '',
    // -----------------------------------------
    totalTransactionNumber: 0,
    totalTransactionAmount: 0,
    // -----------------------------------------

    // dashboard report
    pendingReports: [],
    failedReports: [],
    successfulReports: [],
    // -----------------------------------------

    transactionsInGroup: [],
    // -----------------------------------------
    selectedReport: null,

    // transaction report
    transactionReports: {
      data: [],
      totalRecords: 0
    },

    // transaction history
    transactionHistory: {
      data: [],
      totalRecords: 0
    },

    transactionsByGroupDetails: {
      data: [],
      totalRecords: 0
    }
  }),

  getters: {
    _transactionHistoryFilterOption: (state) => state.transactionHistoryFilterOption,
    _transactionReportFilterOption: (state) => state.transactionReportFilterOption,
    // -------------------------------------------------------------------------------

    // dashboard summary
    _totalPendingTransactionNumber: (state) => state.totalPendingTransactionNumber,
    _totalPendingTransactionAmount: (state) => state.totalPendingTransactionAmount,
    _totalFailedTransactionNumber: (state) => state.totalFailedTransactionNumber,
    _totalFailedTransactionAmount: (state) => state.totalFailedTransactionAmount,
    _totalSuccessfulTransactionNumber: (state) => state.totalSuccessfulTransactionNumber,
    _totalSuccessfulTransactionAmount: (state) => state.totalSuccessfulTransactionAmount,
    _dateRange: (state) => state.dateRange,
    _dateArray: (state) => state.dateArray,
    // ---------------------------------------
    _totalTransactionNumber: (state) => state.totalTransactionNumber,
    _totalTransactionAmount: (state) => state.totalTransactionAmount,
    // -------------------------------------------------------------------------------

    // transaction report
    _pendingReports: (state) => state.pendingReports,
    _failedReports: (state) => state.failedReports,
    _successfulReports: (state) => state.successfulReports,
    // -------------------------------------------------------------------------------
    _transactionsInGroup: (state) => state.transactionsInGroup,
    // ---------------------------------------
    _selectedReport: state => state.selectedReport,

    // transaction report
    _transactionReports: state => state.transactionReports,
    // transaction history
    _transactionHistory: state => state.transactionHistory,

    _transactionsByGroupDetails: state => state.transactionsByGroupDetails
  },

  mutations: {
    TRANSACTION_HISTORY_FILTER_OPTION (state, data) {
      state.transactionHistoryFilterOption = data
    },
    TRANSACTION_REPORT_FILTER_OPTION (state, data) {
      state.transactionReportFilterOption = data
    },
    // -------------------------------------------------------------------------------

    // dashboard summary
    TOTAL_PENDING_TRANSACTION_NUMBER (state, data) {
      state.totalPendingTransactionNumber = data
    },
    TOTAL_PENDING_TRANSACTION_AMOUNT (state, data) {
      state.totalPendingTransactionAmount = data
    },
    TOTAL_FAILED_TRANSACTION_NUMBER (state, data) {
      state.totalFailedTransactionNumber = data
    },
    TOTAL_FAILED_TRANSACTION_AMOUNT (state, data) {
      state.totalFailedTransactionAmount = data
    },
    TOTAL_SUCCESSFUL_TRANSACTION_NUMBER (state, data) {
      state.totalSuccessfulTransactionAmount = data
    },
    TOTAL_SUCCESSFUL_TRANSACTION_AMOUNT (state, data) {
      state.totalSuccessfulTransactionNumber = data
    },
    DATE_RANGE (state, data) {
      state.dateRange = data
    },
    DATE_ARRAY (state, data) {
      state.dateArray = data
    },
    // -----------------------------------------------------
    TOTAL_TRANSACTION_NUMBER (state, data) {
      state.totalTransactionAmount = data
    },
    TOTAL_TRANSACTION_AMOUNT (state, data) {
      state.totalTransactionNumber = data
    },
    // -----------------------------------------------------

    // transaction report
    PENDING_REPORTS (state, data) {
      state.pendingReports = data
    },
    FAILED_REPORTS (state, data) {
      state.failedReports = data
    },
    SUCCESSFUL_REPORTS (state, data) {
      state.successfulReports = data
    },
    // ------------------------------------------------------

    TRANSACTIONS_IN_GROUP (state, data) {
      state.transactionsInGroup = data
    },
    // ------------------------------------------------------
    SELECTED_REPORT (state, data) {
      state.selectedReport = data
    },

    // transaction report
    TRANSACTION_REPORTS (state, { totalRecords, data }) {
      state.transactionReports.totalRecords = parseInt(totalRecords)
      state.transactionReports.data = data
    },

    // transaction history
    TRANSACTION_HISTORY (state, { totalRecords, data }) {
      state.transactionHistory.totalRecords = parseInt(totalRecords)
      state.transactionHistory.data = data
    },

    TRANSACTIONS_BY_GROUP_DETAILS (state, { totalRecords, data }) {
      state.transactionsByGroupDetails.totalRecords = parseInt(totalRecords)
      state.transactionsByGroupDetails.data = data
    }
  },

  actions: {
    // dashboard summary
    GetSummaryAllTransaction ({ rootState, dispatch }, { merchantId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/Report/GetSummaryAllTransaction?MerchantId=${merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            if (response.responseCode === '04') {
              // const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              // store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    // ------------------------------------------------------------------------

    // transaction history
    GetAllTransaction ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/Report/GetAllTransaction?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionPending ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionPending?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionSuccessful ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionSuccessful?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionFailed ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionFailed?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    // ------------------------------------------------------------------------

    // transaction report

    DownloadTransaction ({ rootState, dispatch }, { fundDisbursementId, config }) {
      return new Promise((resolve, reject) => {
        api({
          url: `/Report/DownloadTransaction?FundDisbursementId=${fundDisbursementId}`,
          method: 'GET',
          responseType: 'blob', // file type to be returned
          headers: config.headers
        })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroup ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroup?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroupAknowleged ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroupAknowleged?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroupCompleted ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroupCompleted?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroupDebited ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroupDebited?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroupValidated ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroupValidated?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroupFailed  ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroupFailed?PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&AuthorizerGroupId=${paginationParams.authorizerGroupId}&MerchantId=${paginationParams.merchantId}&DateFrom=${paginationParams.startDate}&DateTo=${paginationParams.endDate}&SearchValue=${paginationParams.searchValue}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetAllTransactionByGroupDetails ({ rootState, dispatch }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(
          `/Report/GetAllTransactionByGroupDetails?SearchValue=${paginationParams?.searchValue}&PageNumber=${paginationParams?.page}&PageSize=${paginationParams?.pageSize}&FundDisbursementId=${paginationParams?.fundDisbursementId}&ProcessingStatus=${paginationParams?.processingStatus}`,
          config
        )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    }
  }
}

export default report
